<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <img src="/climbingforce_200x200.png" style="height: 100px; padding-right: 2em;" />
      <div class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-start">
        <a class="navbar-item" href="/timers">Timers</a>
        <a class="navbar-item" href="/setup">Setup</a>
      </div>
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-primary">
              <strong>Sign up</strong>
            </a>
            <a class="button is-light">
              Log in
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'SiteHeader',
    data () {
      return {
        showNav: false
      }
    }
  }
</script>

<style></style>
